<template>
  <div>
    <div class="posFixed" v-if="/^(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(this.$store.state.previewImgUrl.split('.').pop())">
      <div class="posFixed " @click="closePreviewImg">
      </div>
      <div class="big-img-box">
        <video  controls="controls" >
          <source :src="getImageUrl(previewImgUrl, 1)" type="video/mp4"/>
        </video>
      </div>
    </div>
        <!-- <img v-else :src="previewImgUrl" alt=""> -->
    <div v-else>
      <div class="big-img-box">
        <div>
          <viewer class="viewer" ref="viewer" :images="pics" :options="options"
                style="width: 100%;height: 100%;background-size: contain;background-repeat: no-repeat;
                    background-position: center;background-color: #3e5c9a;">
                <img v-for="(img, index) in pics" :src="getImageUrl(img,index==single?1:'')"
                    :key="index" style="display:none" />
          </viewer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import config from "@/common/env.js";
  export default {
    name: "preview-image",
    data:()=>{
      return {
        pics: [],
        previewImgUrl:'',
        options:{
          title:false,
          initialViewIndex:0,
					viewed(e) {
						let _src = e.detail.image.src;
						if(_src.indexOf("penaltiesBook") != -1 || _src.indexOf("certificate") != -1) {
							this.viewer.rotateTo(-90)
						}
					}
        },
        single:'',
      } 
    },
    beforeMount() {
      this.options.initialViewIndex=localStorage.getItem('myIndex');
      this.pics=JSON.parse(localStorage.getItem('myPics'));
      this.single=localStorage.getItem('single');
    },
    mounted(){
      let that=this;
      this.pics=[];
      this.previewImgUrl=this.$store.state.previewImgUrl;
      setTimeout(() => {
        // that.showViewer()
      }, 1000);
    },
    watch:{
      previewImgUrl(newVal,oldVal){
        let that=this;
        if(newVal){
          this.pics=[];
          // this.pics.push(newVal)
          if(/^(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(this.$store.state.previewImgUrl.split('.').pop())){

          }else{
            that.showViewer();
          }
        }
      }
    },
    computed: {
      // previewImgUrl() {
      //   return this.$store.state.previewImgUrl;
      // },
      imgUrl() {
        //console.log(this.$store.state.imgUrl)
        return this.$store.state.imgUrl;
      },
    },
    beforeDestroy() {
      localStorage.removeItem('myIndex');
      localStorage.removeItem('myPics');
    },
    methods: {
      getImageUrl(url, type) {
        // if(url.indexOf('my_staff') != -1) {
        //   console.log(123, url)
        //   url = url.slice(8)
        //   type = true;
        // }
        let str = type ? "/file/server/file" : "/file/server/decrypt/file";
        return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
      },
      closePreviewImg() {
        this.$store.commit('HIDE_PREVIEW_IMG');
      },
      showViewer() {
        const vuer = this.$refs['viewer'].$viewer;
        vuer.show();
        vuer.view(this.options.initialViewIndex);
      },
    }

  }
</script>

<style scoped>
  /*.big-img-box {*/
    /*cursor: pointer;*/
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
  /*}*/
  .posFixed{
    cursor: pointer;
    z-index: 999999999;
  }

  .big-img-box img, .big-img-box video {
    max-width: 80%;
    max-height: 80%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 999999999;
  }
</style>



// WEBPACK FOOTER //
// preview-image-single.vue?d5e5dd3a